var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(socket) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(socket.readyState >= 2)) {
              _context.next = 2;
              break;
            }

            throw new Error('socket closed');

          case 2:
            if (!(socket.readyState === 1)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var remove = socket && (socket.removeEventListener || socket.removeListener);

              function cleanup() {
                if (typeof remove === 'function') {
                  remove.call(socket, 'open', handleOpen);
                  remove.call(socket, 'error', handleErr);
                }
              }

              function handleOpen() {
                cleanup();
                resolve();
              }

              function handleErr(evt) {
                cleanup();
                reject(evt);
              }

              socket.addEventListener('open', handleOpen);
              socket.addEventListener('error', handleErr);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();